// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3P6Mh","signatureButtonsRight":"ModalSign_signatureButtonsRight__207Fp"};